import "App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import SignIn from "Pages/SignIn";
import Home from "Pages/Home";
import Notice from "Pages/Notice";
import Manage from "Pages/Manage";
import AdminManage from "Pages/AdminManage";
import Inquiry from "Pages/Inquiry";
import CsReview from "Pages/CsReview";
import PopUp from "Pages/PopUp";
import Application from "Pages/Agencies";
import ApplicationDetail from "Pages/AgenciesDetail";
import SelfApplication from "Pages/SelfApplication";
import ErrorPage from "Pages/ErrorPage";
import { useEffect } from "react";
import SelfApplicationDetail from "Pages/SelfApplicationDetail";
import ReviewPage from "Pages/ReviewPage";
import ReviewDetail from "Pages/ReviewDetail";
import BrandName from "Pages/BrandName";
import PaymentsHistory from "Pages/PaymentsHistory";
import AddAgenciesDetail from "Components/AddAgenciesDetail";
import EmailSendModal from "Pages/EmailSendModal";
import PossibilityInfringement from "Pages/PossibilityInfringement";
import ApplicationInfo from "Pages/ApplicationInfo";
import ApplicationInfoDetail from "./Pages/ApplicationInfoDetail";
import UploadFilePage from "Pages/UploadFilePage";
import Faq from "Pages/Faq";
import BetaPage from "Pages/BetaPage";
import ApplicationCalculator from "Pages/ApplicationCalculator";
import Coupon from "Pages/Coupon";
import SideBar from "Components/SideBar";
import GenerateStamp from "Pages/GenerateStamp";
import WorkMemo from "Pages/WorkMemo";
import WorkMemoDetail from "Pages/WorkMemoDetail";
import SalesDashboard from "Pages/SalesDashboard";
import Statistics from "Pages/Statistics";
import Analytics from "Pages/Analytics";
import Blog from "Pages/Blog";
import BlogEdit from "Pages/BlogEdit";
import PatentDesignRequest from "Pages/PatentDesignRequest";
import PatentDesignRequestDetail from "Pages/PatentDesignRequestDetail";
import { NewCountProvider } from "Contexts/NewCountContext";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  // SignIn 페이지에서는 사이드바 숨김
  const showSidebar = pathname !== "/";

  const appBody = (
    <>
      {showSidebar && <SideBar />}

      <main style={{
        marginLeft: showSidebar ? '260px' : '0',
        minHeight: '100vh',
        transition: 'margin-left 0.3s ease'
      }}>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/home" element={<Home />} />
          <Route path="/manage" element={<Manage />} />
          <Route path="/admin-manage" element={<AdminManage />} />
          <Route path="/self-application" element={<SelfApplication />} />
          <Route
            path="/self-application/:id"
            element={<SelfApplicationDetail />}
          />
          <Route path="/agencies" element={<Application />} />
          <Route path="/agencies/:id" element={<ApplicationDetail />} />
          <Route path="/patent-design" element={<PatentDesignRequest />} />
          <Route path="/patent-design/:id" element={<PatentDesignRequestDetail />} />
          <Route
            exact
            element={<ApplicationCalculator />}
            path="/application-calculator"
          />
          <Route path="/inquiry" element={<Inquiry />} />
          <Route path="/cs-review" element={<CsReview />} />
          <Route path="/notice" element={<Notice />} />
          <Route path="/popup" element={<PopUp />} />
          <Route path="/bandname" element={<BrandName />} />
          <Route path="/payments-history" element={<PaymentsHistory />} />
          <Route path="/review-self" element={<ReviewPage />} />
          <Route path="/review-self/:id" element={<ReviewDetail />} />
          <Route path="/add-agencies-detail" element={<AddAgenciesDetail />} />
          <Route path="/send-email" element={<EmailSendModal />} />
          <Route path="/faq" element={<Faq />} />
          <Route
            path="/possibility-infringement"
            element={<PossibilityInfringement />}
          />
          <Route path="/application-info" element={<ApplicationInfo />} />
          <Route path="/fileList" element={<UploadFilePage />} />
          <Route path="/coupon" element={<Coupon />} />
          <Route
            path="/application-info/:id"
            element={<ApplicationInfoDetail />}
          />
          <Route path="/make-image" element={<BetaPage />} />
          <Route path="/rect-stamp" element={<GenerateStamp />} />

          {/* 업무 메모 */}
          <Route path="/work-memo" element={<WorkMemo />} />
          <Route path="/work-memo/:id" element={<WorkMemoDetail />} />

          {/* 매출 관리 */}
          <Route path="/sales-dashboard" element={<SalesDashboard />} />

          {/* 통계 */}
          <Route path="/statistics" element={<Statistics />} />
          <Route path="/analytics" element={<Analytics />} />

          {/* 블로그 관리 */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/new" element={<BlogEdit />} />
          <Route path="/blog/:id" element={<BlogEdit />} />

          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </main>

      {/* 모바일 반응형 스타일 */}
      <style>{`
        @media (max-width: 768px) {
          main {
            margin-left: 0 !important;
          }
        }
      `}</style>
    </>
  );

  return (
    <div className="App">
      {showSidebar ? (
        <NewCountProvider>{appBody}</NewCountProvider>
      ) : (
        appBody
      )}
    </div>
  );
}

export default App;